module.exports = {
  ALL: 'all',
  PINNED: 'pinned',
  SAVED: 'saved',
  RECENT: 'recent',
};
